import { useEffect, useState } from "react";
import type { Startup } from "@crucible/types";
import { useApi } from "@/app/providers/ApiProvider";
import { PageHeader } from "@/shared/ui/PageHeader";

export function DashboardPage() {
  const api = useApi();
  const [startups, setStartups] = useState<Startup[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    api
      .listStartups()
      .then((data) => {
        if (active) setStartups(data);
      })
      .catch((err: Error) => {
        if (active) setError(err.message);
      });
    return () => {
      active = false;
    };
  }, [api]);

  return (
    <section>
      <PageHeader
        eyebrow="Batch"
        title="Portfolio dashboard"
        subtitle="Live startup rows from the API gateway."
      />
      {error && <p className="muted">{error}</p>}
      <div className="card-grid">
        {startups.map((s) => (
          <article key={s.slug} className="card">
            <h3>{s.name}</h3>
            <p className="muted">{s.blurb}</p>
            <span className={`pill pill--${s.status}`}>{s.status}</span>
          </article>
        ))}
        {!error && startups.length === 0 && (
          <p className="muted">Loading portfolio…</p>
        )}
      </div>
    </section>
  );
}